import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Container, Button, Label } from 'reactstrap';
import { Icon } from 'semantic-ui-react';
import { withStyles, Card } from '@material-ui/core';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import * as Constants from '../../Pages/Constants';
import { FormattedMessage } from 'react-intl';
import DeleteShare from '../Shares/DeleteShare.js';
import AddCorrespondantPopup from '../Correspondant/AddCorrespondantPopup.js';
import DeleteCorrespondantPopup from '../Correspondant/DeleteCorrespondantPopup.js';
import Utils from "../Common/Utils.js";
import PatientFunctionsGetter from '../../Controller/getSQLPatientFunctions.js';
import { userIsInPsadStructure, userIsStructureAdminOf } from '../../Controller/userRoles.js';

const INSDataDisplay = (props) => {

  const { classes } = props;
  const [message, setMessage] = useState("");
  const [displayUnsharePopup, setDisplayUnsharePopup] = useState(false);
  const [displayAddCorrespondantPopup, setDisplayAddCorrespondantPopup] = useState(false);
  const [displayDeleteCorrespondantPopup, setDisplayDeleteCorrespondantPopup] = useState(false);
  const [mailToUnshare, setMailToUnshare] = useState("");
  const [addSign, setAddSign] = useState(<i className="fas fa-plus action mr-2"></i>);
  const [structureShares, setStructureShares] = useState([]);
  const [removingStructureShareId, setRemovingStructureShareId] = useState(null);
  const [structureShareToRemove, setStructureShareToRemove] = useState(null);
  const [pendingStructureInvites, setPendingStructureInvites] = useState([]);
  const [cancellingInviteId, setCancellingInviteId] = useState(null);
  const [delegateShareToRevoke, setDelegateShareToRevoke] = useState(null);
  const [revokingMyDelegate, setRevokingMyDelegate] = useState(false);

  const isPatientOwner = props.accountInformation.email === props.profileData.Patient_Data.FK_User_mail;
  // A structure share can also be stopped by the structure that RECEIVED it,
  // which is what TWAPP006 step 15 asks for. The backend already authorizes it
  // (DELETE .../structure_shares/:structure_id accepts an admin of that
  // structure), so the tab has to offer the control to those accounts too.
  const canStopStructureShare = (share) =>
    isPatientOwner || userIsStructureAdminOf(props.accountInformation, share && share.id_structure);
  const isPsad = userIsInPsadStructure(props.accountInformation);

  useEffect(() => {
    PatientFunctionsGetter.get_patient_structure_shares(props.profileData.Patient_Data.id_patient)
      .then(shares => setStructureShares(shares || []));
    PatientFunctionsGetter.get_patient_pending_invites(props.profileData.Patient_Data.id_patient)
      .then(invites => setPendingStructureInvites(
        (invites || []).filter(inv => inv.recipient_structure_id)
      ));
  }, [props.profileData.Patient_Data.id_patient, props.refreshSignal]);

  //Function to handle unshare popup display
  const ManageUnsharePatientDisplay = (mail) => {
    setMailToUnshare(mail);
      setDisplayUnsharePopup(!displayUnsharePopup)
  }

  //Function to handle add correspondant popup display
  const ManageAddCorrespondantDisplay = () => {
      setDisplayAddCorrespondantPopup(!displayAddCorrespondantPopup)
  }

  const handleClickButtonCorrespondant = async() => {
    await props.reloadUserAndProfiles();
    setDisplayAddCorrespondantPopup(!displayAddCorrespondantPopup)
  }

  const handleClickButtonDeleteCorrespondant = async() => {
    await props.reloadUserAndProfiles();
    setDisplayDeleteCorrespondantPopup(!displayDeleteCorrespondantPopup)
  }

  //Function to close popup after patient unshare
  const closeAfterUnshare = async() => {
      await props.reloadUserAndProfiles();
    ManageUnsharePatientDisplay("");
  };

  const renderUsername = () => {
    if(props.profileData.Patient_Data.correspondant !== undefined && props.profileData.Patient_Data.correspondant !== null && props.profileData.Patient_Data.correspondant !== "null" && props.profileData.Patient_Data.correspondant !== "") {
      if((props.profileData.Patient_Data.correspondant.category !== undefined && props.profileData.Patient_Data.correspondant.category !== null && props.profileData.Patient_Data.correspondant.category !== "null" && props.profileData.Patient_Data.correspondant.category !== "") ||
         (props.profileData.Patient_Data.correspondant.profession !== undefined && props.profileData.Patient_Data.correspondant.profession !== null && props.profileData.Patient_Data.correspondant.profession !== "null" && props.profileData.Patient_Data.correspondant.profession !== "") ||
         (props.profileData.Patient_Data.correspondant.msmail !== undefined && props.profileData.Patient_Data.correspondant.msmail !== null && props.profileData.Patient_Data.correspondant.msmail !== "null" && props.profileData.Patient_Data.correspondant.msmail !== "")) {
            return(
              <div>
              <b><FormattedMessage id="account.RPPS_num" defaultMessage="RPPS number: " /></b> {props.profileData.Patient_Data.correspondant.username} <br/>
              </div>
            )
      }
      else if (props.profileData.Patient_Data.correspondant.username !== undefined && props.profileData.Patient_Data.correspondant.username !== null & props.profileData.Patient_Data.correspondant.username !== "null" && props.profileData.Patient_Data.correspondant.username !== "") {
        return(
          <div>
          <b><FormattedMessage id="account.username" defaultMessage="Username: " /></b> {props.profileData.Patient_Data.correspondant.username} <br/>
          </div>
        )
      }
      else {
        return null
      }
    }
    else {
      return null
    }
  }

  //Function to render patient identification elements
  const renderCorrespondant = () => {
    return(
        <div>
          <hr />
          <Row className="justify-content-md-end" style = {{ paddingTop:"10px", paddingBottom: "10px"}}>
            <Col style={{ fontWeight: "bold", fontSize:"1.1em", textAlign: "center" }}>
              <FormattedMessage id="patient.correspondant" defaultMessage="Correspondant"/>
            </Col>
          </Row>
          <br/>
          {renderUsername()}
          {(((props.profileData.Patient_Data.correspondant !== undefined)&&(props.profileData.Patient_Data.correspondant !== null)&&(props.profileData.Patient_Data.correspondant !== "null")) &&
            ((props.profileData.Patient_Data.correspondant.username !== undefined)&&(props.profileData.Patient_Data.correspondant.username !== null)&&(props.profileData.Patient_Data.correspondant.username !== "null"))) ?
            <div>
            <b><FormattedMessage id="account.exercise_name" defaultMessage="Exercise name: " /></b> {props.profileData.Patient_Data.correspondant.lastName} <br/>
            <b><FormattedMessage id="account.lastname" defaultMessage="Lastname: " /></b> {props.profileData.Patient_Data.correspondant.lastName} <br/>
            <b><FormattedMessage id="account.firstname" defaultMessage="First name: " /></b> {props.profileData.Patient_Data.correspondant.firstName} <br/>
            <b><FormattedMessage id="account.categoryTitle" defaultMessage="Category: " /></b>
            <FormattedMessage id="account.category" defaultMessage=" " values={{category: props.profileData.Patient_Data.correspondant.category}} /> <br/>
            <b><FormattedMessage id="account.professionTitle" defaultMessage="Profession: " /></b>
            <FormattedMessage id="account.profession" defaultMessage=" " values={{profession: props.profileData.Patient_Data.correspondant.profession}} /> <br/>
            <b><FormattedMessage id="account.mssantemail" defaultMessage="Mssantemail email address : " /></b> {props.profileData.Patient_Data.correspondant.msmail} <br/>
            </div>
            :
            null
          }
        </div>
    )
  }


  const handleRemoveStructureShare = (share) => {
    setStructureShareToRemove(share);
  };

  const confirmRemoveStructureShare = async () => {
    if (!structureShareToRemove) return;
    const id_structure = structureShareToRemove.id_structure;
    const wasDelegate = structureShareToRemove.sharing_type === 'delegate_medical_alert';
    // Removing a concerned_speciality practitioner also clears the patient's
    // rpps_id_practioner_speciality on the backend, so refresh to stay in sync.
    const wasSpeciality = structureShareToRemove.sharing_type === 'concerned_speciality';
    setRemovingStructureShareId(id_structure);
    setStructureShareToRemove(null);
    await PatientFunctionsGetter.delete_patient_structure_share(
      props.profileData.Patient_Data.id_patient, id_structure
    );
    setStructureShares(prev => prev.filter(s => s.id_structure !== id_structure));
    setRemovingStructureShareId(null);
    // A receiving structure that stops the share loses the profile altogether:
    // reload so it leaves the list instead of lingering until the next refresh.
    if (wasDelegate || wasSpeciality || !isPatientOwner) await props.reloadUserAndProfiles();
  };

  const confirmRevokeMyDelegateShare = async () => {
    if (!delegateShareToRevoke) return;
    setRevokingMyDelegate(true);
    setDelegateShareToRevoke(null);
    await PatientFunctionsGetter.revoke_my_delegate_share(
      props.profileData.Patient_Data.id_patient,
      delegateShareToRevoke.id_structure
    );
    setStructureShares(prev => prev.filter(s => !(
      s.sharing_type === 'delegate_medical_alert' &&
      String(s.FK_target_user) === String(props.accountInformation.id_user) &&
      s.id_structure === delegateShareToRevoke.id_structure
    )));
    setRevokingMyDelegate(false);
    await props.reloadUserAndProfiles();
  };

  const handleCancelPendingInvite = async (request_id) => {
    setCancellingInviteId(request_id);
    await PatientFunctionsGetter.delete_patient_pending_invite(
      props.profileData.Patient_Data.id_patient, request_id
    );
    setPendingStructureInvites(prev => prev.filter(inv => inv.request_id !== request_id));
    setCancellingInviteId(null);
  };

  const displayPendingStructureInvites = () => {
    if (!pendingStructureInvites || pendingStructureInvites.length === 0) return null;
    return (
      <div style={{ marginBottom: '10px' }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: '8px',
          marginBottom: '6px', paddingBottom: '4px',
          borderBottom: '1px solid #f0ad4e'
        }}>
          <span style={{
            display: 'inline-block',
            width: '10px', height: '10px',
            borderRadius: '50%',
            backgroundColor: '#f0ad4e',
            flexShrink: 0
          }} />
          <span style={{ fontWeight: 'bold', fontSize: '0.9em', color: '#856404' }}>
            <FormattedMessage id="share.pendingStructureTitle" defaultMessage="Invitations en attente" />
          </span>
        </div>
        {pendingStructureInvites.map(inv => (
          <Row key={inv.request_id} style={{
            display: 'flex', flexDirection: 'row', alignItems: 'center',
            justifyContent: 'center', width: '100%', marginBottom: '4px',
            padding: '6px 8px',
            backgroundColor: '#fffbf0',
            border: '1px solid #ffe69c',
            borderRadius: '6px'
          }}>
            <Col style={{ textAlign: 'center', padding: 0 }}>
              <FormattedMessage id="share.pendingWithStructure" defaultMessage="En attente : " />
              <b>{inv.recipient_structure_name || inv.recipient_structure_id}</b>
              <span style={{
                marginLeft: '8px',
                display: 'inline-block',
                padding: '1px 8px',
                borderRadius: '10px',
                backgroundColor: '#f0ad4e',
                color: '#fff',
                fontSize: '0.78em',
                fontWeight: 'bold',
                verticalAlign: 'middle'
              }}>
                <FormattedMessage id="invitation.statusPending" defaultMessage="En attente" />
              </span>
            </Col>
            {isPatientOwner && (
              <Col xs="auto" style={{ padding: 0, marginLeft: '8px' }}>
                {cancellingInviteId === inv.request_id ? (
                  <span style={{ fontSize: '0.8em', color: '#888' }}>…</span>
                ) : (
                  <button
                    style={{ borderRadius: '5px', border: '1px solid #dc3545', background: 'none', color: '#dc3545', padding: '1px 7px', cursor: 'pointer', fontSize: '0.8em' }}
                    onClick={() => handleCancelPendingInvite(inv.request_id)}
                    title="Annuler l'invitation"
                  >
                    <FormattedMessage id="button.cancelReq" defaultMessage="Annuler" />
                  </button>
                )}
              </Col>
            )}
          </Row>
        ))}
      </div>
    );
  };

  const displayStructureShares = () => {
    if (!structureShares || structureShares.length === 0) return null;
    return (
      <div>
        {structureShares.map(share => {
          const rowKey = share.id_structure + '_' + (share.FK_target_user || 'wide');
          if (share.sharing_type === 'delegate_medical_alert') {
            const grantorName = [share.grantor_firstname, share.grantor_lastname].filter(Boolean).join(' ') || share.grantor_email || share.grantor_structure_name || share.structure_name;
            const isMyGrant = props.accountInformation.id_user && String(props.accountInformation.id_user) === String(share.FK_target_user);
            const delegateName = [share.target_user_firstname, share.target_user_lastname].filter(Boolean).join(' ') || share.target_user_email;
            return (
              <Row key={rowKey} style={{display: 'flex', flexDirection: "row", textAlign: 'center', justifyContent: 'center', alignItems: 'center', width: "100%", marginBottom: "4px", padding: "6px 8px", backgroundColor: "#f0f4ff", border: "1px solid #c5d0e8", borderRadius: "6px"}}>
                <Col style={{padding: 0}}>
                  <span style={{display: 'inline-block', padding: '1px 8px', borderRadius: '10px', backgroundColor: '#6c8ebf', color: '#fff', fontSize: '0.78em', fontWeight: 'bold', marginRight: '6px', verticalAlign: 'middle'}}>
                    <FormattedMessage id={isPsad ? "share.delegateNonMedicalAlert" : "share.delegateMedicalAlert"} defaultMessage={isPsad ? "Délégation alerte non médicale" : "Délégation alerte médicale"} />
                  </span>
                  <FormattedMessage id="share.sharedby" defaultMessage="Partagé par " />
                  <b>{grantorName}</b>
                  {share.grantor_structure_name && (
                    <span style={{marginLeft: '4px', color: '#888'}}>({share.grantor_structure_name})</span>
                  )}
                  {isMyGrant && (
                    <span style={{marginLeft: '4px'}}>
                      <FormattedMessage id="share.forYou" defaultMessage="pour vous" />
                    </span>
                  )}
                  {!isMyGrant && delegateName && (
                    <span style={{marginLeft: '8px', color: '#555', fontSize: '0.9em'}}>→ {delegateName}</span>
                  )}
                  {!isMyGrant && (() => {
                    const emailPart = share.target_user_email && share.target_user_email !== delegateName ? share.target_user_email : '';
                    const rppsPart = share.target_user_rpps ? `RPPS: ${share.target_user_rpps}` : '';
                    const detail = [emailPart, rppsPart].filter(Boolean).join(' — ');
                    return detail ? <span style={{marginLeft: '6px', color: '#888', fontSize: '0.85em'}}>({detail})</span> : null;
                  })()}
                </Col>
                {isMyGrant && (
                  <Col xs="auto" style={{padding: 0, marginLeft: '8px', display: 'flex', alignItems: 'center'}}>
                    {revokingMyDelegate ? (
                      <span style={{fontSize: "0.85em", color: "#888"}}><FormattedMessage id="share.remove" defaultMessage="Suppression du partage, veuillez patienter..." /></span>
                    ) : (
                      <button style={{borderRadius: "5px"}} onClick={() => setDelegateShareToRevoke(share)} title="Ne plus voir ce patient">
                        <LinkOffIcon color="inherit" fontSize="inherit" />
                      </button>
                    )}
                  </Col>
                )}
                {isPatientOwner && (
                  <Col xs="auto" style={{padding: 0, marginLeft: '8px', display: 'flex', alignItems: 'center'}}>
                    {removingStructureShareId === share.id_structure ? (
                      <span style={{fontSize: "0.85em", color: "#888"}}><FormattedMessage id="share.remove" defaultMessage="Suppression du partage, veuillez patienter..." /></span>
                    ) : (
                      <button style={{borderRadius: "5px"}} onClick={() => handleRemoveStructureShare(share)}>
                        <LinkOffIcon color="inherit" fontSize="inherit" />
                      </button>
                    )}
                  </Col>
                )}
              </Row>
            );
          }
          if (share.FK_target_user) {
            const userEmail = share.target_user_email || [share.target_user_firstname, share.target_user_lastname].filter(Boolean).join(' ');
            return (
              <Row key={rowKey} style={{display: 'flex', flexDirection: "row", textAlign: 'center', justifyContent: 'center', width: "100%", marginBottom: "4px"}}>
                <FormattedMessage id="share.sharedwith" defaultMessage="Shared with " />
                <span style={{marginLeft: "4px"}}>→ <b>{userEmail}</b></span>
                {share.target_user_structure_name && (
                  <span style={{marginLeft: "4px", color: "#888"}}>({share.target_user_structure_name})</span>
                )}
                {share.grantor_structure_name && (
                  <span style={{marginLeft: "4px", color: "#888"}}>
                    <FormattedMessage id="share.invitedByStructure" defaultMessage="invité par " />{share.grantor_structure_name}
                  </span>
                )}
                {isPatientOwner && (
                  <div className="push" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: "8px"}}>
                    {removingStructureShareId === share.id_structure ? (
                      <span style={{fontSize: "0.85em", color: "#888"}}><FormattedMessage id="share.remove" defaultMessage="Suppression du partage, veuillez patienter..." /></span>
                    ) : (
                      <button style={{borderRadius: "5px"}} onClick={() => handleRemoveStructureShare(share)}>
                        <LinkOffIcon color="inherit" fontSize="inherit" />
                      </button>
                    )}
                  </div>
                )}
              </Row>
            );
          }
          return (
            <Row key={rowKey} style={{display: 'flex', flexDirection: "row", textAlign: 'center', justifyContent: 'center', width: "100%", marginBottom: "4px"}}>
              <FormattedMessage id="share.structuresharedwith" defaultMessage="Partagé avec la structure " />
              <b style={{marginLeft: "4px"}}>{share.structure_name}</b>
              {share.structure_type ? <span style={{marginLeft: "4px", color: "#888"}}>({share.structure_type})</span> : null}
              {canStopStructureShare(share) && (
                <div className="push" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: "8px"}}>
                  {removingStructureShareId === share.id_structure ? (
                    <span style={{fontSize: "0.85em", color: "#888"}}><FormattedMessage id="share.remove" defaultMessage="Suppression du partage, veuillez patienter..." /></span>
                  ) : (
                    <button style={{borderRadius: "5px"}} onClick={() => handleRemoveStructureShare(share)}>
                      <LinkOffIcon color="inherit" fontSize="inherit" />
                    </button>
                  )}
                </div>
              )}
            </Row>
          );
        })}
      </div>
    );
  };

  /**   /!\ TRANSLATION /!\  **/
  //Function to launch unshare popup display and ask user to confirm (or not) unshare
  const deleteShare = async (email) => {
    if(props.accountInformation.email === props.profileData.Patient_Data.FK_User_mail){
      setMessage(<FormattedMessage id = "share.deleteQuestionOwner" defaultMessage = {"Are you sure you want to stop sharing that profile with " + email + "?"} values = {{account_mail: email}} />)
    }
    else{
      setMessage(<FormattedMessage id = "share.deleteQuestionReceiver" defaultMessage = {"Are you sure you want to remove that share from " + email + "?"} values = {{account_mail: email}} />)
    }
    ManageUnsharePatientDisplay(email);
  }

  // ###### RENDER FUNCTIONS ######

  const displaySharedWith = () => {
    return (
      <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
        {props.profileData.Patient_Data.shares.email.map((email,index)=>{
          if (email !== props.accountInformation.email) {
            return (
              <Row key={index} style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
                <FormattedMessage id="share.sharedwith" defaultMessage="Profile owner"/>
                {email}
                <div className="push" style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                {props.accountInformation.readOnly === true || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("patient_add_delete_block")) ?
                  null
                  :
                  <button style={{ borderRadius: "5px"}} onClick={() => deleteShare(email)}>
                    <LinkOffIcon color="inherit" fontSize="inherit" />
                  </button>
                }
                </div>
                <br/>
              </Row>
            )
          }
        })}
      </Row>
    )
  }

    return(
      <div style={{width:"100%"}}>
      {//Display the first part: patient internal, or shared by someone
        props.profileData.Patient_Data.FK_User_mail !== props.accountInformation.email ?
        <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
          <FormattedMessage id="share.sharedby" defaultMessage="External profile : "/>
            {props.profileData.Patient_Data.FK_User_mail}
            {props.profileData.Patient_Data.owner_structure_name && (
              <span style={{marginLeft: "4px", color: "#888"}}>({props.profileData.Patient_Data.owner_structure_name})</span>
            )}
          <div className="push" style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            {props.accountInformation.readOnly === true || Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("patient_add_delete_block")) ?
              null
              :
            <button style={{ borderRadius: "5px"}} onClick={() => deleteShare(props.profileData.Patient_Data.FK_User_mail)}>
            <LinkOffIcon color="inherit" fontSize="inherit" />
          </button>
            }
          </div>
        </Row>
          :
        <Row style={{display: 'flex', flexDirection:"row", textAlign: 'center', justifyContent: 'center', width:"100%"}}>
          <div className="push" style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            {props.profileData.Patient_Data.share_info.owner} <FormattedMessage id="share.isOwner" defaultMessage="Profile owner"/><br/>
          </div>
        </Row>
        }
      {//Display the second part: if patient shared, display list
        props.profileData.Patient_Data.shares !== false ?
        displaySharedWith()
            :
            null
        }
      {//Display the third part: structure shares from table_patient_structure_share
        displayPendingStructureInvites()
      }
      {//Display the fourth part: confirmed structure shares
        displayStructureShares()
      }
          {structureShareToRemove ? (
            <div className={classes.popup_background}>
              <Container style={{ height: "100%", width: "100%" }} fluid>
                <Row style={{ height: "100%", width: "100%" }} className="g-0">
                  <Col xs="1" md="3" lg="4"></Col>
                  <Col xs="10" md="6" lg="4" style={{ height: "100%", display: "grid", placeItems: "center" }}>
                    <Card style={{
                      width: "100%",
                      backgroundColor: "white",
                      borderRadius: "10px",
                      overflow: "hidden",
                      boxShadow: "0 8px 32px rgba(0,0,0,0.18)"
                    }}>
                      {/* Header bar */}
                      <div style={{
                        backgroundColor: "#c0392b",
                        padding: "16px 20px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px"
                      }}>
                        <LinkOffIcon style={{ color: "white", fontSize: "1.6em" }} />
                        <span style={{ color: "white", fontWeight: "bold", fontSize: "1.05em" }}>
                          <FormattedMessage id="share.stopShare" defaultMessage="Arrêter le partage" />
                        </span>
                      </div>
                      {/* Body */}
                      <div style={{ padding: "24px 24px 8px 24px", textAlign: "center" }}>
                        <div style={{ fontSize: "1em", color: "#333", marginBottom: "8px" }}>
                          <FormattedMessage id="share.stopStructureConfirm" defaultMessage="Voulez-vous arrêter le partage avec :" />
                        </div>
                        <div style={{
                          fontSize: "1.2em",
                          fontWeight: "bold",
                          color: "#c0392b",
                          margin: "10px 0 18px 0",
                          padding: "8px 16px",
                          backgroundColor: "#fdf0ef",
                          borderRadius: "6px",
                          border: "1px solid #f5c6c3"
                        }}>
                          {structureShareToRemove.structure_name}
                        </div>
                      </div>
                      {/* Buttons */}
                      <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "0 24px 24px 24px",
                        gap: "12px"
                      }}>
                        <Button
                          onClick={() => setStructureShareToRemove(null)}
                          color="secondary"
                          outline
                          style={{ flex: 1, borderRadius: "6px", fontWeight: "500" }}
                        >
                          <FormattedMessage id="button.cancel" defaultMessage="Annuler" />
                        </Button>
                        <Button
                          onClick={confirmRemoveStructureShare}
                          color="danger"
                          style={{ flex: 1, borderRadius: "6px", fontWeight: "500" }}
                        >
                          <FormattedMessage id="share.stopShare" defaultMessage="Arrêter le partage" />
                        </Button>
                      </div>
                    </Card>
                  </Col>
                  <Col xs="1" md="3" lg="4"></Col>
                </Row>
              </Container>
            </div>
          ) : null}
          {delegateShareToRevoke ? (
            <div className={classes.popup_background}>
              <Container style={{ height: "100%", width: "100%" }} fluid>
                <Row style={{ height: "100%", width: "100%" }} className="g-0">
                  <Col xs="1" md="3" lg="4"></Col>
                  <Col xs="10" md="6" lg="4" style={{ height: "100%", display: "grid", placeItems: "center" }}>
                    <Card style={{ width: "100%", backgroundColor: "white", borderRadius: "10px", overflow: "hidden", boxShadow: "0 8px 32px rgba(0,0,0,0.18)" }}>
                      <div style={{ backgroundColor: "#c0392b", padding: "16px 20px", display: "flex", alignItems: "center", gap: "10px" }}>
                        <LinkOffIcon style={{ color: "white", fontSize: "1.6em" }} />
                        <span style={{ color: "white", fontWeight: "bold", fontSize: "1.05em" }}>
                          <FormattedMessage id="share.revokeMyDelegateAccess" defaultMessage="Ne plus voir ce patient" />
                        </span>
                      </div>
                      <div style={{ padding: "24px 24px 8px 24px", textAlign: "center" }}>
                        <div style={{ fontSize: "1em", color: "#333", marginBottom: "8px" }}>
                          <FormattedMessage id="share.revokeMyDelegateConfirm" defaultMessage="Vous ne verrez plus ce patient. Continuer ?" />
                        </div>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", padding: "0 24px 24px 24px", gap: "12px" }}>
                        <Button onClick={() => setDelegateShareToRevoke(null)} color="secondary" outline style={{ flex: 1, borderRadius: "6px", fontWeight: "500" }}>
                          <FormattedMessage id="button.cancel" defaultMessage="Annuler" />
                        </Button>
                        <Button onClick={confirmRevokeMyDelegateShare} color="danger" style={{ flex: 1, borderRadius: "6px", fontWeight: "500" }}>
                          <FormattedMessage id="share.revokeMyDelegateAccess" defaultMessage="Ne plus voir ce patient" />
                        </Button>
                      </div>
                    </Card>
                  </Col>
                  <Col xs="1" md="3" lg="4"></Col>
                </Row>
              </Container>
            </div>
          ) : null}
          {displayUnsharePopup ?
            <DeleteShare
              message={message}
              closeAfterUnshare={closeAfterUnshare}
              accountInformation={props.accountInformation}
              structure_Id={props.structure_Id}
              subscription_info={props.subscription_info}
              cancelPopup = {ManageUnsharePatientDisplay}
              patient={props.profileData}
          mailToUnshare={mailToUnshare}
            />
            :
            null
          }
          {displayAddCorrespondantPopup ?
              <AddCorrespondantPopup
                id_user={props.accountInformation.id_user}
                id_patient={props.profileData.Patient_Data.id_patient}
                cancelPopup={handleClickButtonCorrespondant}
                patient={props.profileData}
              />
              :
              null
          }
          {displayDeleteCorrespondantPopup ?
              <DeleteCorrespondantPopup
                FK_structure={props.accountInformation.FK_structure}
                patient_data={props.profileData}
                cancelPopup={handleClickButtonDeleteCorrespondant}
              />
              :
              null
          }
        </div>
        )
}

export default withStyles(Constants.styles)(INSDataDisplay);
